<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__semi-reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-messaging-rule-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>
    <div *ngIf="loading" class="table__no-items">Loading message rule details...</div>

    <ng-container *ngIf="!loading && ruleSetData">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-slide-toggle
          [checked]="ruleSetData.active"
          (click)="$event.stopPropagation()"
          (change)="activateOrDeactivateRule($event)"></mat-slide-toggle>

        <h2 fxFlex class="nomargin input__editable">
          <input
            #nameInput
            class="input__borderless"
            type="text"
            [style.width.px]="nameInput.value.length * 13"
            [(ngModel)]="ruleSetData.name"
            (change)="updateRuleSet()" />
        </h2>

        <sbnb-cs-debug-item
          label="ruleset_id"
          [value]="ruleSetId"
          [coreNovaLink]="'/resources/rulesets/' + ruleSetId"
          linkLabel="Nova"
          [borderTop]="true"></sbnb-cs-debug-item>
        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <div
        class="rule__section-container"
        style="border-top: 0"
        *ngIf="ruleSetData.event === 'checkpoint' && ruleSetData?.metadata?.msg_to_guest_start_only">
        <sbnb-note
          [type]="NoteType.Warning"
          [id]="'rule_checkpoint_nls'"
          [isDismissible]="true"
          [content]="
            'We are no longer able to notify users when a guest is required to verify their identity. This notification setting is still found in the Setting UI but there is a request to have it removed.'
          "></sbnb-note>
      </div>

      <div class="rule__section-container">
        <h3 fxLayoutAlign="start center" fxLayoutGap="12px" class="not-clickable">
          <sbnb-icon icon="message" class="text-smoke-darker"></sbnb-icon>
          <span>Message</span>
          <span fxHide.lt-md class="card__collapsed-helper-text">
            {{
              ruleSetData.event.startsWith('question:')
                ? 'Do not include greetings in your reply, these will be added automatically when needed.'
                : 'The message that will be sent to your guest. You can use short codes and custom codes by typing %.'
            }}
          </span>
        </h3>

        <div>
          <sbnb-rule-editor
            #ruleEditor
            [ruleSetId]="ruleSetId"
            [ruleType]="ruleSetData.event"
            [importEnabled]="true"
            [ruleSetData]="ruleSetData"
            (saveStatusChange)="ruleSaveStatusChange($event)"></sbnb-rule-editor>
        </div>
      </div>

      <div class="rule__section-container rule__section-collapsed">
        <div fxLayout fxLayoutAlign="start center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
          <h3
            class="not-clickable"
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px">
            <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>Timing</span>
          </h3>
          <sbnb-rule-timing
            *ngIf="timingsMeta && ruleSetData && timingsMeta.event.key !== 'recurring:weekly'"
            [meta]="timingsMeta"
            [ruleset]="ruleSetData"
            (triggerSave)="timingUpdated($event)"></sbnb-rule-timing>

          <sbnb-rule-timing-recurring
            *ngIf="timingsMeta && ruleSetData && timingsMeta.event.key === 'recurring:weekly'"
            [meta]="timingsMeta"
            [ruleset]="ruleSetData"
            (triggerSave)="timingUpdated($event)"></sbnb-rule-timing-recurring>
        </div>
        <span
          fxHide.lt-md
          class="card__collapsed-helper-text card__collapsed-helper-text-newline"
          *ngIf="ruleSetData.event === 'scheduled:accepted'">
          “After a new reservation” messages will not be sent if the check-in time has passed.
        </span>
      </div>

      <div
        *ngIf="
          ruleSetData.event === 'inquiry' ||
          ruleSetData.event === 'checkin' ||
          ruleSetData.event === 'checkout' ||
          ruleSetData.event === 'recurring:weekly' ||
          ruleSetData.event === 'scheduled:accepted' ||
          ruleSetData.event.startsWith('question') ||
          ruleSetData.event === 'scheduled:accepted' ||
          ruleSetData.event === 'recurring:weekly'
        "
        class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
            <img src="/assets/iconography/settings.svg" />
            <span>Settings</span>
            <span class="card__collapsed-helper-text">Fine-tune preferences for this rule.</span>
          </h3>
        </div>

        <div>
          <sbnb-rule-settings
            [settings]="ruleSetData.metadata"
            [image]="ruleSetData.picture"
            [rulesetId]="ruleSetId"
            [rulesetType]="ruleSetData.event"
            [showSkipLastMinute]="ruleSetData.timing?.when === 'before'"
            [rulesetTiming]="ruleSetData.timing"
            (updated)="handlesettingsChange($event)"></sbnb-rule-settings>
        </div>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-icon icon="scope" class="text-smoke-darker"></sbnb-icon>
            <span>Scope</span>
            <span class="card__collapsed-helper-text">Limit the usage of this rule with the options below.</span>
          </h3>
        </div>

        <div>
          <sbnb-rule-scope [initial]="ruleSetData" (completed)="handleScopeChange($event)"></sbnb-rule-scope>
        </div>
      </div>

      <div class="rule__section-container">
        <div fxFlex fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
          <sbnb-button
            label="Delete"
            icon="delete"
            type="text"
            [labelColor]="'#ED3C6A'"
            (clicked)="deleteRulesetPrompt()"></sbnb-button>

          <sbnb-button
            label="Copy"
            icon="copy"
            type="text"
            [labelColor]="'#ED3C6A'"
            (clicked)="copyRuleset()"></sbnb-button>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
